module.exports = __webpack_public_path__ + "img/email.ee55dfe1.svg";